export default __webpack_public_path__ + "locales/lv/BackupCodesDialog.json?hash=94b9a41ba2ac83da552450d1be39cf89";